import { Pipe, PipeTransform } from '@angular/core';

import { Cloudinary } from '@cloudinary/url-gen';
import BackwardTransformation from '@cloudinary/url-gen/backwards/transformation';

import { Team } from '../data/models/collections/team';
import { UrlService } from './url.service';

@Pipe({
  name: 'avatarUrl',
})
export class AvatarUrlPipe implements PipeTransform {
  constructor(
    private cloudinary: Cloudinary,
    private urlService: UrlService
  ) {}

  transform(team: Team): string {
    const color: string = team?.displayProfile?.family?.backgroundColor;
    const icon: string = team?.displayProfile?.family?.icon?.url;

    if (!color || !team?.seo) {
      return '';
    }

    const SIZE = 500;
    const ICON_SIZE = Math.round(SIZE / 3);
    const LOGO_WIDTH = 75;

    const image = this.cloudinary
      .image(this.urlService.parsePublicId((team.consent?.imageDisplay && team.seo.image.url) || 'nobody_profile_ac17932b5e'))
      .addTransformation(
        new BackwardTransformation({
          background: color,
          opacity: 40,
          gravity: 'face',
          effect: 'grayscale',
          height: SIZE,
          width: SIZE,
          crop: 'thumb',
        }).toString()
      )
      .addTransformation(
        new BackwardTransformation({
          width: Math.round(SIZE / 5),
          height: SIZE,
          gravity: 'north_west',
          opacity: 100,
          background: color,
          overlay: `text:Roboto%20Condensed_60_bold: `,
          crop: 'thumb',
        }).toString()
      );

    const agencyLogo = 'medium_logo_white_d1cd1d6c1a';
    image.addTransformation(
      new BackwardTransformation({
        width: LOGO_WIDTH,
        height: 21,
        gravity: 'south_east',
        overlay: agencyLogo,
        crop: 'fill',
        x: 20,
        y: 20,
      }).toString()
    );

    if (icon) {
      image.addTransformation(
        new BackwardTransformation({
          width: ICON_SIZE,
          height: ICON_SIZE,
          gravity: 'north_west',
          overlay: this.urlService.parsePublicId(icon),
          crop: 'pad',
          radius: '100',
          x: Math.round(SIZE / 5 - ICON_SIZE / 2),
          y: Math.round((SIZE - ICON_SIZE) / 2),
        }).toString()
      );
    }

    return decodeURI(image.toURL());
  }
}
